export enum OptOutReasons {
  HaveOtherHealthCoverage,
  DontHaveIndividualInsurance,
  CoveredByParentsInsurance,
  PlanToTakePremiumTaxCredit,
}
